import { RouteObject } from 'react-router'
import adminToolsRoutes from './adminTools/routes'
import dashboardRoutes from './dashboard/routes'
import engagementRoutes from './engagement/routes'
import integrationsRoutes from './integrations/routes'
import logsRoutes from './logs/routes'
import platformSetupRoutes from './platformSetup/routes'
import pointsAndRewardsRoutes from './pointsAndRewards/routes'
import reportsRoutes from './reports/routes'
import userManagementRoutes from './userManagement/routes'

const routes: RouteObject[] = [
  ...dashboardRoutes,
  ...adminToolsRoutes,
  ...engagementRoutes,
  ...userManagementRoutes,
  ...pointsAndRewardsRoutes,
  ...logsRoutes,
  ...reportsRoutes,
  ...platformSetupRoutes,
  ...integrationsRoutes,
]

export default routes
